import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const ChecklistCheckItemAllDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChecklistCheckItemAll"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checklist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"None"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"all"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"ChecklistCheckItemAll","document":ChecklistCheckItemAllDocument}} as const;
export type ChecklistCheckItemAllQueryVariables = Types.Exact<{
  parentId: Types.Scalars['ID'];
}>;


export type ChecklistCheckItemAllQuery = (
  { __typename: 'Query' }
  & { checklist?: Types.Maybe<(
    { __typename: 'Checklist' }
    & Pick<Types.Checklist, 'id'>
    & { checkItems: Array<(
      { __typename: 'CheckItem' }
      & Pick<Types.CheckItem, 'id'>
    )> }
  )> }
);




/**
 * __useChecklistCheckItemAllQuery__
 *
 * To run a query within a React component, call `useChecklistCheckItemAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useChecklistCheckItemAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChecklistCheckItemAllQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useChecklistCheckItemAllQuery(baseOptions: Apollo.QueryHookOptions<ChecklistCheckItemAllQuery, ChecklistCheckItemAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChecklistCheckItemAllQuery, ChecklistCheckItemAllQueryVariables>(ChecklistCheckItemAllDocument, options);
      }
export function useChecklistCheckItemAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChecklistCheckItemAllQuery, ChecklistCheckItemAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChecklistCheckItemAllQuery, ChecklistCheckItemAllQueryVariables>(ChecklistCheckItemAllDocument, options);
        }
export type ChecklistCheckItemAllQueryHookResult = ReturnType<typeof useChecklistCheckItemAllQuery>;
export type ChecklistCheckItemAllLazyQueryHookResult = ReturnType<typeof useChecklistCheckItemAllLazyQuery>;
export type ChecklistCheckItemAllQueryResult = Apollo.QueryResult<ChecklistCheckItemAllQuery, ChecklistCheckItemAllQueryVariables>;